import { Layout } from 'antd';
import { Content } from 'antd/es/layout/layout';
import Breadcrumb from 'src/components/v1/Breadcrumb';
import './ReportLayout.scss';

interface Props {
  children?: React.ReactNode;
}

export default function ReportLayout({ children }: Props) {
  return (
    <div className='modern-report-layout'>
      <div className='report-breadcrumb-container'>
        <Breadcrumb />
      </div>
      <div className='report-main-content'>
        <Layout style={{ background: 'transparent' }}>
          <Content className='report-content-wrapper'>
            <div className='report-content-inner'>{children}</div>
          </Content>
        </Layout>
      </div>
    </div>
  );
}
